export default __webpack_public_path__ + "static/media/recruiter-avatar.a0f86465.svg";